import { apiService } from "@/common/api.service.js";

export default {
  // Dashboard sites by company
  companyDashboardSites(company) {
    const endpoint = `/api/company-dashboard-sites/${company}/`;
    return apiService(endpoint);
  },

  // SEU Dashboard (Power BI)
  SEUDashboard(payload) {
    const endpoint = `/power-bi/seu-dashboard/`;
    return apiService(endpoint, "POST", payload);
  },
};
